export default "__VITE_ASSET__CVWy4Zjw__";